import { render, staticRenderFns } from "./MyInfoPage.vue?vue&type=template&id=13d57fa0"
import script from "./MyInfoPage.vue?vue&type=script&lang=js"
export * from "./MyInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports